import {Component, EventEmitter, Input, Output} from '@angular/core';
import {environment} from "../../../../environments/environment";


@Component({
    selector: 'file-uploader',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploaderComponent {

    @Input() activeColor:string = 'green';
    @Input() baseColor:string = '#ccc';
    @Input() overlayColor:string = 'rgba(255,255,255,0.5)';

    @Output() onFileChange: EventEmitter<File> = new EventEmitter();

    dragging: boolean = false;
    loaded: boolean = false;
    imageLoaded: boolean = false;
    imageSrc: string = '';

    handleDragEnter() {
        this.dragging = true;
    }

    handleDragLeave() {
        this.dragging = false;
    }

    handleDrop(e) {
        e.preventDefault();
        this.dragging = false;
        this.handleInputChange(e);
    }

    handleImageLoad() {
        this.imageLoaded = true;
        //this.iconColor = this.overlayColor;
    }

    handleInputChange(e) {
        var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        var imgPattern = /image-*/;
        var pdfPattern = /.pdf/;

        var reader = new FileReader();

        if ( file.type.match(imgPattern) ) {
            this.loaded = false;
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsDataURL(file);
            this.onFileChange.emit(file);
        } else if ( file.type.match(pdfPattern) ) {
            this.imageSrc = "/assets/images/adobe-pdf-icon.png";
            this.onFileChange.emit(file);
        } else {
            alert('Formato invalido');
            return;
        }

    }

    _handleReaderLoaded(e) {
        var reader = e.target;
        this.imageSrc = reader.result;
        this.loaded = true;
    }

    _setActive() {
        //this.borderColor = this.activeColor;
        if (this.imageSrc.length === 0) {
            //this.iconColor = this.activeColor;
        }
    }

    _setInactive() {
        //this.borderColor = this.baseColor;
        if (this.imageSrc.length === 0) {
            //this.iconColor = this.baseColor;
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/core/commons/file-upload/file-upload.component.ts